import { useRef as a, useEffect as s } from "react";
import { useEventListener as h } from "./useEventListener.js";
var L = function(c, n, o, f, t) {
  t === void 0 && (t = 100);
  var r = a(n);
  s(function() {
    r.current = n;
  }, [n]);
  var e = a(null);
  h("touchstart", !!n && function(u) {
    u.touches.length === 1 && (e.current = u.touches[0].clientX);
  }, o, f), h("touchend", !!n && function(u) {
    if (!(!r.current || e.current === null)) {
      var i = u.changedTouches[0].clientX, l = i - e.current;
      (c === "onSwipeRight" && l > t || c === "onSwipeLeft" && l < -t) && (r.current == null || r.current(u)), e.current = null;
    }
  }, o, f);
};
export {
  L as u
};
